import { useFeatureFlags } from "hooks/useFeatureFlags";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { episodicEventsEnabled } from "./episodicFlags";

/** Route gate for the episodic events page, same shape as HasFlag but over the combined rule. */
export function EpisodicEventsGate({
  fallback,
  children,
}: PropsWithChildren<{ fallback: string }>) {
  const { featureFlags, loading } = useFeatureFlags();
  if (loading) {
    return <></>;
  }
  return episodicEventsEnabled(featureFlags) ? <>{children}</> : <Navigate to={fallback} replace />;
}
